import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { isConfirmed, isRightLengthPassword, required } from '@/lib/rule';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetPasswordForm',
  props: {
    password: null,
    passwordComfirmation: null,
    passwordMinLength: null
  },
  emits: ["update:isValidForm", "update:password", "update:passwordComfirmation"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValidForm', data: boolean): void;
  (e: 'update:password', data: string): void;
  (e: 'update:passwordComfirmation', data: string): void;
}), expose: any, slots: any, attrs: any }) {





const isValidForm = ref<boolean>(false);
const showPassword = ref<boolean>(false);
const showPasswordConfirmation = ref<boolean>(false);

const updateIsValidForm = (e: boolean) => {
  emits('update:isValidForm', e);
};

const updatePassword = (e: string) => {
  emits('update:password', e);
};

const updatePasswordComfirmation = (e: string) => {
  emits('update:passwordComfirmation', e);
};

return { __sfc: true,emits, isValidForm, showPassword, showPasswordConfirmation, updateIsValidForm, updatePassword, updatePasswordComfirmation, isConfirmed, isRightLengthPassword, required, sharedMessages }
}

})